import React, { Component } from 'react'
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { MDBDataTableV5, MDBCol, MDBTableBody, MDBTableHead } from 'mdbreact';
import { Link } from 'react-router-dom';

import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import GetApiCall from '../../GETAPI';
import moment from 'moment';
import Parser from "html-react-parser";


import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

class cutomerList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allDetails: [],
            isdeleted: false,
            searchInput: ''


        };
    }
    

    componentDidMount() {
        var login = localStorage.getItem("LoginDetail");
        var details = JSON.parse(login);
        // console.log(details[0])
        this.setState({
          Usertype: details[0].fld_usertype,
        });
        console.log("this.state.Usertype  " + this.state.Usertype )
        if (details[0].fld_usertype != "Admin")
        {
          window.location.href = "/"
          }
        Notiflix.Loading.Init({
            svgColor: 'rgb(216, 23, 100)'

        });

        Notiflix.Loading.Dots('');

        GetApiCall.getRequest("Get_New_AllClosedAccountList").then(resultdes =>
            resultdes.json().then(obj => {

             

                this.setState({
                    allDetails: obj.data
                })


                Notiflix.Loading.Remove();
            }))

    }

    // viewdetail = (data) => {
    //     if (this.state.isdeleted === false) {
    //         return (
    //             localStorage.setItem('ClientDetails', [JSON.stringify(data)]),

    //             this.props.history.push('/edit_client')
    //         )
    //     }
    //     else if (this.state.isdeleted === true) {
    //         return (
    //             localStorage.setItem('ClientDetails', [JSON.stringify(data)]),
    //             this.props.history.push('/view-clients')
    //         )

    //     }

    // }


    // fld_gender

    // fld_accountNumber: "df5434"
    // fld_id: 1
    // fld_remarks: "asdf"
    // fld_status


    seachBarHandler = (e) => {
        this.setState({ ...this.state, searchInput: e.target.value })
    }
    render() {

        const data = {
            columns: [
                {
                    label: "S no.",
                    field: "serial",
                    sort: "disabled",
                    width: 50
                },
                {
                    label: "Name",
                    field: "name",
                    sort: "disabled",
                    width: 200
                },
                {
                    label: "Account number",
                    field: "accountNumber",
                    sort: "disabled",
                    width: 270
                },

                {
                    label: "Status",
                    field: "status",
                    sort: "disabled",
                    width: 150
                },
                {
                    label: "Action",
                    field: "action",
                    sort: "disabled",
                    width: 150
                }
            ],
            rows:
                this.state.allDetails.filter(data => {

                    if (this.state.searchInput.length == 0) {
                        return data
                    }
                    if (this.state.searchInput !== '' &&
                        (data.FLD_NAME.toLowerCase().includes(this.state.searchInput.toLowerCase()) ||

                            `${data.FLD_ACCOUNTNO ? data.FLD_ACCOUNTNO : ''}`.includes(this.state.searchInput.toLowerCase())
                        )

                    ) {
                        //   console.log('searchdata' + data)
                        return data
                    }



                }).map((data, i) => {
                    return {
                        serial: <td>{(i + 1)}</td>,
                        name: <td>{data.FLD_NAME}</td>,
                        accountNumber: <td>{data.FLD_ACCOUNTNO}</td>,
                        status: <td>{data.FLD_CLIENTSTATUS == null || data.FLD_CLIENTSTATUS == '' ? 'Closed' : data.FLD_CLIENTSTATUS}</td>,
                        action: <td>
                            <button className={'btn'}
                                style={{ backgroundColor: '#880105', color: '#e1b761', float: 'right', }}
                                onClick={() => {
                                    confirmAlert({
                                        title: 'Confirm to Open Account',
                                        message: 'Are you sure you want to Open the account.',
                                        buttons: [
                                            {
                                                label: 'Yes',
                                                onClick: () => {
                                                    Notiflix.Loading.Dots('Please wait...');

                                                    PostApiCall.postRequest({
                                                        id: data.chitid,
                                                        clientstatus: 'Approved',


                                                    }, "CloseAccount").then((result) =>
                                                        result.json().then(obj5 => {
                                                            if (result.status == 200 || result.status == 201) {


                                                                Notiflix.Loading.Remove();
                                                                Notiflix.Notify.Success('Account is Successfully Approved.')
                                                                window.location.reload()
                                                            } else {
                                                                Notiflix.Loading.Remove()
                                                                Notiflix.Loading.Failure(obj5.data);
                                                            }
                                                        })
                                                    )
                                                }
                                            },
                                            {
                                                label: 'No',
                                                // onClick: () => alert('Click No')
                                            }
                                        ]
                                    });


                                }}
                            >Approve</button>
                        </td>

                    }
                })
        };





        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                        {/* Render Breadcrumb */}
                        <Breadcrumbs title={'Manage Clients'} breadcrumbItem={'View Clients'} />
                        <Row>
                            <Col xl="12">

                                <Card className="overflow-hidden">
                                    <div className="maxXchange-bg-soft-pink" style={{ background: 'rgb(171, 61, 0)' }}>
                                        <Row>


                                            <Col xs="6">
                                                <div className="maxXchange-text p-3"><h5 className="maxXchange-text">Close Account </h5>

                                                </div>
                                            </Col>


                                        </Row>
                                        <Row>

                                        </Row>
                                    </div>

                                    <Card className="overflow-hidden">
                                        <div className="maxXchange-bg-soft-pink" style={{ background: '#dfb65c' }}>
                                            <Row>


                                                <Col xs="6">
                                                    <div className="maxXchange-text p-3">
                                                        <h5 className="maxXchange-text">Close Account List</h5>

                                                    </div>
                                                </Col>


                                            </Row>
                                        </div>
                                        <CardBody className="pt-0">
                                            <Row>
                                                <MDBCol md="4" style={{ marginBottom: '10px', marginTop: '10px' }}>
                                                    <input className="form-control" type="text" placeholder="Search"
                                                        aria-label="Search" onChange={(e) => this.seachBarHandler(e)}
                                                        value={this.state.searchInput} />
                                                </MDBCol>
                                                <Col md="12">

                                                    <MDBDataTableV5

                                                        striped
                                                        bordered
                                                        small
                                                        data={data}
                                                        searchBottom={false}
                                                        seachTop={true}
                                                    >

                                                        <MDBTableHead columns={data.columns} />
                                                        <MDBTableBody rows={data.rows} />
                                                    </MDBDataTableV5>

                                                </Col>

                                            </Row>
                                        </CardBody>
                                    </Card>


                                    {/* <WelcomeComp /> */}


                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
export default cutomerList